import { Map } from 'immutable';
import { createSelector } from 'reselect';

import {
  createHasActiveRequestSelectorFor,
  createFailedRequestSelectorFor,
} from 'redux-flight-control';

import { assetsStoreSelector } from 'redux/assets/selectors';

import {
  CANCEL_SERVICE_REQUEST,
  CREATE_SERVICE_REQUEST,
  LOAD_SERVICE_REQUEST,
} from '../constants';

/* --------------------------- REQUEST SELECTORS --------------------------- */

/* --------------------------- CANCEL_SERVICE_REQUEST --------------------------- */

export const cancelServiceRequestPendingSelector =
  createHasActiveRequestSelectorFor(CANCEL_SERVICE_REQUEST);

export const cancelServiceRequestErrorSelector =
  createFailedRequestSelectorFor(CANCEL_SERVICE_REQUEST);

/* --------------------------- CREATE_SERVICE_REQUEST --------------------------- */

export const createServiceRequestPendingSelector =
  createHasActiveRequestSelectorFor(CREATE_SERVICE_REQUEST);

export const createServiceRequestErrorSelector =
  createFailedRequestSelectorFor(CREATE_SERVICE_REQUEST);

/* --------------------------- LOAD_SERVICE_REQUEST --------------------------- */

export const loadServiceRequestPendingSelector =
  createHasActiveRequestSelectorFor(LOAD_SERVICE_REQUEST);

export const loadServiceRequestErrorSelector =
  createFailedRequestSelectorFor(LOAD_SERVICE_REQUEST);


/* --------------------------- SERVICE REQUEST STORE SELECTORS --------------------------- */

// For convenience, extract the serviceRequests section of the store.
const serviceRequestsStoreSelector = state => state.get('serviceRequests');

const currentServiceRequestIdSelector = createSelector(
  serviceRequestsStoreSelector,
  serviceRequestStore => serviceRequestStore.get('currentServiceRequestId'),
);

export const currentServiceRequestSelector = createSelector(
  serviceRequestsStoreSelector,
  currentServiceRequestIdSelector,
  (
    serviceRequestsStore,
    currentServiceRequestId,
  ) => (
    (currentServiceRequestId && serviceRequestsStore.getIn(['byId', currentServiceRequestId])) ||
      Map()
  ),
);

export const currentServiceRequestAssetSelector = createSelector(
  currentServiceRequestSelector,
  assetsStoreSelector,
  (
    currentServiceRequest,
    assetsStore,
  ) => (
    (currentServiceRequest && assetsStore.getIn(['byId', currentServiceRequest.get('asset')])) ||
      Map()
  ),
);

export const currentServReqServProvSelector = createSelector(
  currentServiceRequestSelector,
  currentServiceRequest =>
    (currentServiceRequest && currentServiceRequest.get('serviceProvider')) || Map(),
);

export const serviceRequestsRequestingSelector = createSelector(
  serviceRequestsStoreSelector,
  serviceRequestsStore => serviceRequestsStore.get('requesting'),
);

// When all of the cases are required we convert serviceRequests.byId into an immutable list.
export const serviceRequestsSelector = createSelector(
  serviceRequestsStoreSelector,
  serviceRequestsStore => serviceRequestsStore.get('responseIds').map(id =>
    serviceRequestsStore.getIn(['byId', id])).toList(),
);



// WEBPACK FOOTER //
// ./redux/serviceRequests/selectors.js